import { useQuery } from "@tanstack/react-query";
import { programApi, type ProgramEnrollmentQuoteBody } from "@bw/shared/api";
import { useAuth } from "@bw/shared/hooks";
import type { EnrollmentModeQuoteResponse, ProgramPromotionPaymentReview } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

export function useEnrollmentQuote(
  trackId: string | undefined,
  body: ProgramEnrollmentQuoteBody,
  enabled = true,
) {
  const requiresOccurrence = body.enrollment_mode === "session_drop_in";
  return useQuery<EnrollmentModeQuoteResponse>({
    queryKey: queryKeys.classes.enrollmentQuote(
      trackId ?? "",
      body.enrollment_mode,
      body.occurrence_start ?? null,
    ),
    queryFn: () => programApi.quoteEnrollment(trackId as string, body),
    enabled: Boolean(trackId) && enabled && (!requiresOccurrence || Boolean(body.occurrence_start)),
    retry: false,
  });
}

export function usePromotionPaymentReview(enrollmentId: string, enabled = true) {
  const { user } = useAuth();
  return useQuery<ProgramPromotionPaymentReview>({
    queryKey: ["classes", "promotion-payment-review", user?.uid, enrollmentId],
    queryFn: () => programApi.getPromotionPaymentReview(enrollmentId),
    enabled: Boolean(user?.uid && enrollmentId) && enabled,
    retry: false,
  });
}
